import * as pako from 'pako';
import {ApiRequestStandardResponse} from '../../api/types';
// tslint:disable-next-line:no-any
export function decompressAndDecodeResponseData(response: ApiRequestStandardResponse): any {
  return JSON.parse(decompressAndDecodeData(response.data));
}

export function decompressAndDecodeData(data: string): string {
  const unbase64 = atob(data);
  const uArray: Uint8Array = new Uint8Array(unbase64.length);
  for (let i=0; i < unbase64.length; i++) {
    uArray[i] =unbase64.charCodeAt(i);
  }
  return pako.inflate(uArray, { to: 'string' });
}
